import React, {useEffect, useState} from "react";
import {Stack, Tab, Tabs} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import {useTranslation} from "react-i18next";
import useResize from "../../hooks/useResize";
import clsx from "clsx";
import {CategoryIconConfig, DEFAULT_CATEGORY_ICON_KEY, FAVORITES_CATEGORY_ID, normalizeCategoryIconKey} from "../../constants"

interface IProps {
    list: any[];
    setSelected?: (value: number | any) => void; // Specify the function type
    setLoading?: (loading: boolean) => void; // Specify the function type
    withoutAll?: boolean;
    selectedValue?: number;
    onFetch?: any;
    reset?: boolean;
    children?: React.ReactNode;
    categories?: boolean;
    className?: string;
    categoryIconsByName?: Record<string, CategoryIconConfig>;
}

const CustomTabs: React.FC<IProps> = ({
                                          list,
                                          withoutAll = false,
                                          reset,
                                          selectedValue,
                                          onFetch,
                                          setLoading,
                                          setSelected,
                                          categories = false,
                                          className,
                                          categoryIconsByName,
                                      }) => {
    const [value, setValue] = useState<number>(selectedValue ?? 0);
    const {t} = useTranslation("translations");
    const {innerWidth} = useResize();
    const allLabel = t("Buttons.all");
    const defaultCategoryIcon = categoryIconsByName?.[DEFAULT_CATEGORY_ICON_KEY];
    const allCategoryIcon = categoryIconsByName?.[normalizeCategoryIconKey(allLabel)] ?? defaultCategoryIcon;
    const AllCategoryIcon = allCategoryIcon?.Icon;

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        event.preventDefault();
        setValue(newValue);
        setSelected?.(newValue);
        setLoading?.(true);
    };

    useEffect(() => {
        setValue(0);
    }, [reset]);

    useEffect(() => {
        if (selectedValue === undefined) return;
        setValue(selectedValue);
    }, [selectedValue]);

    return (
        <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons={innerWidth > 860}
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
            sx={{flexGrow: 1}}
            className={clsx(className)}
        >
            {!withoutAll && (
                <Tab
                    label={
                        AllCategoryIcon ? (
                            <Stack direction="row" alignItems="center" spacing={0.75}>
                                <AllCategoryIcon fontSize="small" aria-hidden="true"/>
                                <span>{allLabel}</span>
                            </Stack>
                        ) : (
                            allLabel
                        )
                    }
                    value={0}
                    onClick={onFetch}
                />
            )}
            {list.map((category) => {
                const categoryIcon = categoryIconsByName?.[normalizeCategoryIconKey(String(category.name))] ?? defaultCategoryIcon;
                const CategoryIcon = categoryIcon?.Icon;

                return (
                    <Tab
                        key={category.id}
                        value={category.id}
                        label={
                            categories && category.id === FAVORITES_CATEGORY_ID ? (
                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                <StarIcon
                                fontSize="small"
                                sx={{ color: "rgba(255, 191, 0, 1)" }}
                                />
                                <span>{category.name}</span>
                            </Stack>
                            ) : categoryIcon ? (
                                <Stack direction="row" alignItems="center" spacing={0.75}>
                                    {CategoryIcon && <CategoryIcon fontSize="small" aria-hidden="true"/>}
                                    <span>{category.name}</span>
                                </Stack>
                            ) : (
                            category.name
                            )
                        }
                        />
                );
            })}
        </Tabs>
    );
};

export default CustomTabs;
